/**
 * Analisi del rischio
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 3.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ExcelControllerService {

	protected basePath = 'http://localhost:5003';
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains 'multipart/form-data', false: otherwise
	 */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
	 * Effettua l&#x27;export in excel di un&#x27;analisi
	 *
	 * @param codice
	 * @param storico
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public esportaAnalisiExcel(codice: string, storico?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public esportaAnalisiExcel(codice: string, storico?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public esportaAnalisiExcel(codice: string, storico?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public esportaAnalisiExcel(codice: string, storico?: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (codice === null || codice === undefined) {
			throw new Error('Required parameter codice was null or undefined when calling esportaAnalisiExcel.');
		}


		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (storico !== undefined && storico !== null) {
			queryParameters = queryParameters.set('storico', <any>storico);
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<any>('get', `${this.basePath}/api/v1/excel/${encodeURIComponent(String(codice))}/export-re`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua l&#x27;export in excel delle contromisure
	 *
	 * @param codice
	 * @param storico
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public esportaContromisureAnalisiExcel(codice: string, storico?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public esportaContromisureAnalisiExcel(codice: string, storico?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public esportaContromisureAnalisiExcel(codice: string, storico?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public esportaContromisureAnalisiExcel(codice: string, storico?: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (codice === null || codice === undefined) {
			throw new Error('Required parameter codice was null or undefined when calling esportaContromisureAnalisiExcel.');
		}


		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (storico !== undefined && storico !== null) {
			queryParameters = queryParameters.set('storico', <any>storico);
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<any>('get', `${this.basePath}/api/v1/excel/${encodeURIComponent(String(codice))}/export-contromisure`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua l&#x27;export in excel delle contromisure
	 *
	 * @param codice
	 * @param storico
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public esportaRequisitiAnalisiExcel(codice: string, storico?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public esportaRequisitiAnalisiExcel(codice: string, storico?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public esportaRequisitiAnalisiExcel(codice: string, storico?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public esportaRequisitiAnalisiExcel(codice: string, storico?: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (codice === null || codice === undefined) {
			throw new Error('Required parameter codice was null or undefined when calling esportaRequisitiAnalisiExcel.');
		}


		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (storico !== undefined && storico !== null) {
			queryParameters = queryParameters.set('storico', <any>storico);
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<any>('get', `${this.basePath}/api/v1/excel/${encodeURIComponent(String(codice))}/export-requisitipiano`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua l&#x27;export in excel delle contromisure
	 *
	 * @param codice
	 * @param storico
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public esportaRischiAnalisiExcel(codice: string, storico?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public esportaRischiAnalisiExcel(codice: string, storico?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public esportaRischiAnalisiExcel(codice: string, storico?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public esportaRischiAnalisiExcel(codice: string, storico?: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (codice === null || codice === undefined) {
			throw new Error('Required parameter codice was null or undefined when calling esportaRischiAnalisiExcel.');
		}


		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (storico !== undefined && storico !== null) {
			queryParameters = queryParameters.set('storico', <any>storico);
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<any>('get', `${this.basePath}/api/v1/excel/${encodeURIComponent(String(codice))}/export-rischi`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
